
import { Options, Vue } from 'vue-class-component'
import HelloWorld from '@/components/HelloWorld.vue' // @ is an alias to /src
import Vue3autocounter from 'vue3-autocounter'

@Options({
  components: {
    HelloWorld,
    'vue3-autocounter': Vue3autocounter
  }
})

export default class Home extends Vue {
  // Declare mounted lifecycle hook
  async setup () {
    console.log('HI')
  }

  mounted () {
    const plugin = document.createElement('script')
    plugin.setAttribute(
      'src',
      'https://unpkg.com/embeddable-nfts/dist/nft-card.min.js'
    )
    plugin.async = true
    document.head.appendChild(plugin)
  }

  public async trykk (event: Event, neighbourIds: Array<string>) {
    const tagElement = event?.target as Element
    neighbourIds.forEach(neighbourId => {
      const neighbourElement = document.getElementById(neighbourId)
      if (neighbourElement?.innerHTML === '' && tagElement !== null) {
        console.log('SETTING: ' + tagElement.innerHTML)
        neighbourElement.innerHTML = tagElement.innerHTML
        tagElement.innerHTML = ''
      }
    })
  }

  public mouseover (event: Event) {
    const hackyLink = document.createElement('a')
    hackyLink.target = '_blank'
    hackyLink.href = 'https://t.me/tallrik'
    hackyLink.click()
    window.alert('Its a trap!')
  }
}
